import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section aria-label="Garantía" className="border-b border-ink-700 bg-ink-900 py-16 sm:py-20" data-id="element-77" data-mp="1o2vk0ww891a9">
      <motion.div initial={{
      opacity: 0,
      y: 16
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-60px'
    }} transition={{
      duration: 0.5
    }} className="mx-auto w-full max-w-page px-5 sm:px-8" data-id="element-78" data-mp="2223g3gx3fta8">
        <div className="border border-ink-700 bg-ink-950 p-8 text-center sm:p-12" data-id="element-79" data-mp="14fxq675d1auh">
          <ShieldCheckIcon className="mx-auto h-10 w-10 text-ice" aria-hidden="true" data-id="element-80" data-mp="1j4k5w9ywg4m8" />
          <h2 className="display mt-5 text-3xl text-bone sm:text-4xl" data-id="element-81" data-mp="1j6dg1z8q16yz">7 días — sin preguntas</h2>
          <p className="mt-5 text-base text-ash sm:text-lg" data-id="element-82" data-mp="1ebr5tzedlkgh">
            Abrís. Aplicás. Si no es lo que esperabas:
          </p>
          <p className="display mt-2 text-xl text-bone sm:text-2xl" data-id="element-83" data-mp="lpogydb5oita">
            Devolución del 100%. Sin formularios. Sin drama.
          </p>
          <p className="mt-6 text-xs font-semibold uppercase tracking-[0.18em] text-ash" data-id="element-84" data-mp="oz043x7vy4pd">
            Tasa de devoluciones: menos del 1%
          </p>
        </div>
      </motion.div>
    </section>;
}